<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fluid
    grid-list-md
  >
    <v-layout wrap>
      <!-- SOL -->
      <v-flex
        xs12
        md7
        class="pr-0 pr-md-5"
      >
        <v-card>
          <card-toolbar title="Tekli Rehber Kaydı"></card-toolbar>
          <v-card-text>
            <v-alert
              prominent
              text
              type="info"
            >
              <v-row align="center">
                <v-col class="grow">
                  Seçeceğiniz gruba numaraları tek tek yazarak kayıt oluşturabilirsiniz.
                </v-col>
              </v-row>
            </v-alert>

            <contact-form :data.sync="data">
            </contact-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- SAĞ -->
      <v-flex
        xs12
        md5
      >
        <contact-excel :groups="data.groups">
        </contact-excel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import ContactForm from '../../Components/ContactForm/ContactForm.vue';
import ContactExcel from '../../Components/ContactExcel/ContactExcel.vue';
import CardToolbar from '../../Components/CardToolbar.vue';

export default {
  name: 'Create',
  components: { CardToolbar, ContactExcel, ContactForm },
  data: () => ({
    data: {},
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    // Event form submit butonu, event olarak tanımlı. Sebebi ise form un component olması.
    // eğer event olarak yapmasaydım vue, sürekli hata verecekti. Sebebi ise,
    // çocuk component veli componentin değerini etkileyemez, konsepti.
    submitForm(e, form) {
      this.send({ route: 'add/contact/single', data: form });
    },
  },
  async created() {
    const route = 'add/contact/single/show';

    await this.send({ route }).then(async (res) => {
      this.data = res.data.data;
      (await !!Array.isArray(res.data.data.groups))
        || this.$router.push({ name: 'group.contacts.index' }).catch((err) => {});

      // eslint-disable-next-line no-unused-expressions
      this.data.settings === null ? (this.data.settings = {}) : this.data.settings;

      ['default_message_type', 'default_sender', 'id', 'user_id'].forEach(
        v => delete this.data.settings[v],
      );

      this.data.settings = Object.filter(this.data.settings, v => v !== null);
      if (res.data.data.groups.length === 0) {
        this.$router.push({ name: 'group.contacts.index' }).then(() => {
          this.$trigger('set:notification', 'Öncelikle "Grup" kaydı oluşturmalısınız.');
        });
      }
    });
  },
  events: {
    // Eventler bu şekilde tanımlanıyor. Takma adı, objenin key'i
    // key'in metodu ise değer halinde veriliyor.
    'submit:contact-create': 'submitForm',
    'submit:upload-excel': 'sendFile',
    'on:file-picked': 'onFilePicked',
  },
};
</script>
